import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstName'
})
export class FirstNamePipe implements PipeTransform {
  transform(value: any) {
    if (value && value.includes("@")) {
      return value.substr(0, value.indexOf('@'));;
    }

    return value;
  }

}
